import { DynamicFormV2Palette } from "@mui/material";

export type FormInfoboxComponentTokenType = {
  default: {
    backgroundColor: string;
    textColor: string;
    iconColor: string;
    richIconFillBase: string;
    richIconFillHighlight: string;
    richIconFillSubtle: string;
  };
  emphasis: {
    backgroundColor: string;
    textColor: string;
    iconColor: string;
  };
  error: {
    backgroundColor: string;
    textColor: string;
    iconColor: string;
  };
};

export const assignInfoboxComponentTokens = (formsPalette: DynamicFormV2Palette["forms"], mode: "light" | "dark") => {
  const isLightMode = mode === "light";

  return {
    default: {
      backgroundColor: isLightMode ? formsPalette.surface.quiet : formsPalette.surface.moderate,
      textColor: isLightMode ? formsPalette.text.moderate : formsPalette.text.intense,
      iconColor: formsPalette.text.brand,
      richIconFillBase: formsPalette.text.moderate,
      richIconFillHighlight: formsPalette.text.brand,
      richIconFillSubtle: isLightMode ? formsPalette.surface.moderate : formsPalette.text.brand, // Normally icons should use text tokens, but we make an exception in this case
    },
    emphasis: {
      backgroundColor: isLightMode ? formsPalette.surface.quiet : formsPalette.surface.moderate,
      textColor: isLightMode ? formsPalette.text.brand : formsPalette.text.moderate,
      iconColor: formsPalette.text.brand,
    },
    error: {
      backgroundColor: formsPalette.surface.error,
      textColor: isLightMode ? formsPalette.text.error : formsPalette.text.intense,
      iconColor: isLightMode ? formsPalette.text.error : formsPalette.text.intense,
    },
  } as FormInfoboxComponentTokenType;
};
